<template>
  <collapse :active-index="0">
    <collapse-item body-classes="p-0 m-0">
      <template slot="title">
        <div class="row align-items-center">
          <div class="col-sm-4">
            <h3 class="mb-0">{{ title }}</h3>
          </div>

          <div class="col text-right mr-5">
            <slot name="actions"></slot>
          </div>
        </div>
      </template>

      <div v-if="dataIsLoaded" class="table-responsive">
        <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
          <el-table-column label="Asesor Técnico" min-width="145px" prop="seller">
            <template #default="{ row }">
              <router-link
                v-if="$can('show', 'sellers')"
                :to="{
                  name: 'SellerOrderList',
                  params: { id: row.seller.id },
                  query: { campaign: row.campaign.id, variety: row.variety.id },
                }"
                class="h5"
              >
                {{ row.seller.name }}
              </router-link>
              <span v-else class="h5">{{ row.seller.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Campaña" min-width="145px" prop="campaign">
            <template #default="{ row }">
              <div class="font-weight-bold">{{ row.campaign.name }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Variedad" min-width="145px" prop="variety">
            <template #default="{ row }">
              <div>{{ row.variety.name }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Cantidad" min-width="145px" prop="quantity">
            <template #default="{ row }">
              <span>{{ row.quantity }}</span
              >&nbsp;
              <span class="font-weight-bold">({{ row.variety.crop.unit.toLowerCase() }})</span>
            </template>
          </el-table-column>

          <el-table-column label="Importe (USD)" min-width="145px" prop="amountUsd">
            <template #default="{ row }">
              <span>{{ row.amountUsd | toCurrencyUSD }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Importe (ARS)" min-width="145px" prop="amountUsd">
            <template #default="{ row }">
              <span>{{ row.amountArs | toCurrencyARS }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </collapse-item>
  </collapse>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'SellersSellsTable',
  components: {
    Collapse,
    CollapseItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [PaginationMixin],
  props: {
    title: {
      type: String,
      default: 'Totales por asesor técnico',
    },

    campaign: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      // searchKeys: [],
      results: [],
      dataIsLoaded: false,
    };
  },

  computed: {
    tableData() {
      return this.results;
    },
  },

  created() {
    this.pagination.perPage = 500;
    this.dataIsLoaded = false;
    this.fetchSells();
  },

  methods: {
    fetchSells() {
      this.$services
        .resource('orders_statistics')
        .sellsBySellers({ 'filter[campaign]': this.campaign })
        .then((res) => res.data.data)
        .then((data) => {
          this.results = data.results;
          this.dataIsLoaded = true;
          this.sortBySeller();
        });
    },

    sortBySeller() {
      this.results.sort(this.compare_names);
    },

    compare_names(a, b) {
      if (a.seller.name < b.seller.name) {
        return -1;
      }
      if (a.seller.name > b.seller.name) {
        return 1;
      }
      return 0;
    },

    downloadPdf() {
      let filename = this.title.replaceAll(' ', '-').toLowerCase();
      this.$services.resource('orders_statistics').sellsBySellersPDF({ 'filter[campaign]': this.campaign }, filename);
    },
  },
};
</script>
